import ContentLoader from 'react-content-loader';

import { DEFAULT_SETTINGS } from '@web/newsfeed/ArticleSearch/ArticleSearchSkeleton/articleSearchSkeleton.consts';

export const ArticleDateSkeleton = () => (
  <ContentLoader height={40} viewBox="0 0 150 40" {...DEFAULT_SETTINGS} rtl>
    <rect x="0" y="5" rx="0" ry="0" width="50" height="10" />
    <rect x="0" y="17" rx="0" ry="0" width="70" height="10" />
  </ContentLoader>
);
